import Util, {http} from "@/libs/util";
import util from "@/libs/util";

export const {
    refund_offline_apply_es_query,
    refund_offline_apply_save,
    refund_offline_apply_detail,
    refund_offline_apply_delete,
    refund_offline_apply_reapply,
    refund_offline_apply_ele_receipt,
    refund_offline_apply_refund_pay,
    refund_offline_apply_export,
    cya_spu_select_search_operating,
    refund_offline_apply_batch_import,
    refund_offline_apply_import_template,
    refund_offline_apply_query_batch_import,
    refund_offline_apply_import_attachment,
    batch_pass_user_flow_node_user,
    refund_offline_apply_do_finish,
    third_party_shop_select_list
} = util.api || {};

export function getRefundOfflineApplySaveApi(params) {
    return http.post(refund_offline_apply_save, params);
}

export function getRefundOfflineApplyEsQueryApi(params) {
    return http.get(refund_offline_apply_es_query, params);
}

export function getRefundOfflineApplyDetailApi(params) {
    return http.get(refund_offline_apply_detail, params);
}

export function getRefundOfflineApplyDeleteApi(params) {
    return http.post(refund_offline_apply_delete, params);
}

export function postRefundOfflineApplyReapplyApi(params) {
    return http.post(refund_offline_apply_reapply, params);
}

export function getRefundOfflineApplyEleReceiptApi(params) {
    return window.open(refund_offline_apply_ele_receipt + "?id=" + params.id, '_blank')
}

export function postRefundOfflineApplyRefundPayApi(params) {
    return http.post(refund_offline_apply_refund_pay, params);
}

export function getRefundOfflineApplyExportApi(params) {
    return window.open(refund_offline_apply_export + "?1=1" + Util.urlEncode(params), "_blank");
}

export function getCyaSpuSelectSearchOperatingApi(params) {
    return http.get(cya_spu_select_search_operating, params);
}

export function downloadTemplateFileApi() {
    return window.open(refund_offline_apply_import_template, '_blank')
}

export function postRefundOfflineApplyBatchImportApi(params) {
    return http.post_upload(refund_offline_apply_batch_import, params);
}
export function getRefundOfflineApplyQueryBatchImportApi(params) {
    return http.get(refund_offline_apply_query_batch_import, params);
}
export function getRefundOfflineApplyImportAttachmentApi(params) {
    return window.open(refund_offline_apply_import_attachment + "?id=" + params.id, '_blank')
}
export function batchPassApi(params) {
    return http.post(batch_pass_user_flow_node_user, params)
}
export function postDoFinishApi(params) {
    return http.post(refund_offline_apply_do_finish, params)
}

export function getThirdPartyShopSelectListApi(params) {
    return http.get(third_party_shop_select_list, params)
}